import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Section3() {
  const section = 'section3';
  const title = 'La casa de la abuela';
  const description = 'Unas horas antes de la Noche de Muertos, llegué a casa de mi familia en Tzintzuntzan.';
  const text = '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda porro modi numquam tempore iste quis provident dolorem maiores consectetur id? Quaerat sapiente nemo laborum doloremque repellat nulla explicabo praesentium odio.</p><p>Lorem ipsum dolor sit amet consectetur</p>';
  const image = 'https://www.diadelavida.com/images/chapters/chapter2_sketch.png';
  const imageAlt = 'Chapter 2 sketch';
  const comments_prompt = '¿Qué te pareció este capítulo? ¿Alguna vez has visitado Tzintzunztan? ¡Deja tu comentario!';

  const images = [
    {
      id: 1,
      src: 'https://www.diadelavida.com/images/chapters/capitulo2_main.jpg',
      alt: 'Image 1 description',
      description: 'Detailed description for image 1'
    },
    {
      id: 2,
      src: 'https://diadelavida.com/images/cards/Taquito01.png',
      alt: 'Image 2 description',
      description: 'Detailed description for image 2'
    },
    {
      id: 3,
      src: 'https://diadelavida.com/images/cards/Taquito01.png',
      alt: 'Image 2 description',
      description: 'Detailed description for image 2'
    }
  ];

  return (
    <div>
      <ChapterDisplay
        title={title}
        description={description}
        text={text}
        image={image}
        imageAlt={imageAlt}
        images={images}
      />
      <div id='users-comments'>
        <div className="comments-deco"></div>
        <div className="container">
          <div className="row">
            <Comments sectionId={section} commentsPrompt={comments_prompt} />
          </div>
        </div>
      </div>
    </div>
  );
}